import React, { useEffect } from 'react';

const GoogleLogin = ({ onLoginSuccess, onLoginFailure }) => {
  useEffect(() => {
    // Load the GIS library
    const script = document.createElement('script');
    script.src = 'https://accounts.google.com/gsi/client';
    script.async = true;
    script.defer = true;
    document.body.appendChild(script);

    script.onload = () => {
      // Initialize the Google Identity Services client
      window.google.accounts.id.initialize({
        client_id: '13853097929-eo23ra6sblur4qb20io57qgp2bfdi94m.apps.googleusercontent.com', // Replace with your Client ID
        callback: handleCredentialResponse,
      });

      // Render the Google Sign-In button
      window.google.accounts.id.renderButton(
        document.getElementById('google-login-button'),
        {
          theme: 'outline',
          size: 'large',
        }
      );
    };

    return () => {
      // Cleanup script on component unmount
      document.body.removeChild(script);
    };
  }, []);

  const handleCredentialResponse = (response) => {
    const { credential } = response;
    console.log(credential)
    if (credential) {
      onLoginSuccess(credential);
    } else {
      onLoginFailure('Login failed or canceled.');
    }
  };

  return <div id="google-login-button"></div>;
};

export default GoogleLogin;
